// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1YnUx","content":"styles_content__2APKe","selectAll":"styles_selectAll__3GL4z"};